module.exports = __webpack_public_path__ + "static/media/Kylie-Jenner-2_thumb.6ef950f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/celebrity-influencers/Kylie-Jenner-2_thumb.jpg
// module id = 105
// module chunks = 0